import React, { useEffect } from 'react'
import { useMedia } from 'react-use'
import PropTypes from 'prop-types'
import LoadingOverlay from '../components/LoadingOverlay'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import moment from 'moment-timezone'
import FancySelectAdvanced from '../elements/FancySelect/FancySelectAdvanced'

const options = {
    postUrl: '/api/postUpdateQuietTimeOverride',
    success: 'Timer successfully updated.',
    dontScrollToNav: true,
    showHideIcon: true
}

const state = {
    timezone: ''
}

const hoursList = [
    { value: 0, label: '-' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
    { value: 11, label: '11' },
    { value: 12, label: '12' }
]

const minutesList = [
    { value: 0, label: '-' },
    { value: 15, label: '15' },
    { value: 30, label: '30' },
    { value: 45, label: '45' }
]

const QuietTimeOverrideForm = (props) => {
    const isMobile = useMedia('(max-width: 992px)')

    useEffect(() => {
        props.setDynamicValues({
            timezone: moment.tz.guess()
        })
    }, [])

    const handleCancel = event => {
        event.preventDefault()
        props.handleCancel()
    }

    const FormContent = (
        <React.Fragment>
            <div className='d-flex mt-3 justify-content-center align-items-center'>
                <div className='mr-4'>
                    <p className='font-small sub-bold m-0 mb-1'>&nbsp;</p>
                    <p className='font-small sub-bold m-0'>Set timer</p>
                </div>
                <div className='mr-2'>
                    <p className='font-small sub-bold m-0 mb-1'>Hours</p>
                    <FancySelectAdvanced
                        label='-'
                        list={hoursList}
                        value={props.values.hours}
                        setValue={value => props.setDynamicValues({ hours: value })}
                        className={props.errors && props.errors.hours ? 'error' : ''}
                    />
                </div>
                <div className='mr-2'>
                    <p className='font-small sub-bold m-0 mb-1'>Minutes</p>
                    <FancySelectAdvanced
                        label='-'
                        list={minutesList}
                        value={props.values.minutes}
                        setValue={value => props.setDynamicValues({ minutes: value })}
                        className={props.errors && props.errors.minutes ? 'error' : ''}
                    />
                </div>
                <div className='d-none d-lg-block'>
                    <p className='font-small sub-bold m-0 mb-1'>&nbsp;</p>
                    <Button title='Start' action={props.handleSubmit} />
                </div>
            </div>
            <div className='d-lg-none text-center'>
                <p className='font-small sub-bold m-0 mb-1'>&nbsp;</p>
                <Button title='Start' action={props.handleSubmit} />
            </div>
            {props.children ? <div className='mt-3'>{props.children}</div> : ''}
        </React.Fragment>
    )

    const TimerExists = (
        <div className='mt-4'>
            <div className='text-center mb-3'>
                <p className='font-small m-0 mb-1'>Focus-time enabled until:</p>
                <input
                    value={props.timerEnds}
                    onChange={() => {}}
                    className='bg-spearmintlight text-center'
                    disabled
                    style={{ width: '250px' }}
                />
            </div>
            <div className='text-center'>
                <a href='#' className='font-small' onClick={handleCancel}>Cancel</a>
            </div>
        </div>
    )

    return (
        <LoadingOverlay isLoading={props.isLoading} className='quiet-time-override-form'>
            <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
                <div className='bg-lightergrey py-4 px-2 p-lg-4 h-100'>
                    <div className='text-center mb-2'>
                        <p className='bold m-0'>Enable Focus-time now</p>
                    </div>
                    <div className='text-center'>
                        <p className='font-small mb-0'>You can override scheduling and turn Focus-time content blocking ON/OFF instantly here. Use the timer to switch OFF automatically.</p>
                    </div>
                    {props.timerEnds ? TimerExists : FormContent}
                </div>
            </form>
        </LoadingOverlay>
    )
}

QuietTimeOverrideForm.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    timerEnds: PropTypes.string,
    handleCancel: PropTypes.func.isRequired
}

export default FormHOC(QuietTimeOverrideForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/QuietTimeOverrideForm.js